import { render, staticRenderFns } from "./EmptySection.vue?vue&type=template&id=67d93374&scoped=true&"
import script from "./EmptySection.vue?vue&type=script&lang=js&"
export * from "./EmptySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d93374",
  null
  
)

export default component.exports